import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { subscriptionActions } from '../../../../store/modules/subscription';
import { userActions } from '../../../../store/modules/user';

const useUpdateUserInfoHandler = () => {
  const dispatch = useDispatch();

  const handleInfoUpdate = useCallback(() => {
    dispatch(userActions.getUser());
    dispatch(subscriptionActions.fetchSubscriptionHistory());
  }, []);

  return handleInfoUpdate;
};

export default useUpdateUserInfoHandler;
